import { Rx } from "subtree.js/core";
import type { SellingPath } from "../../core/primitives/onboarding";

export class OnboardingSellingState {
  readonly storeId = new Rx<string | null>(null);
  /** The answer given before, so coming back shows it picked. */
  readonly path = new Rx<SellingPath | null>(null);
}

export abstract class OnboardingSellingActions {
  abstract choose(path: SellingPath): void;
  abstract back(): void;
}
